import api from '../../helpers/axios'

export const state = {
    person: null,
    persons: []
};

export const getters = {
    person: (state) => state.person,
    persons: (state) => state.persons
};

export const mutations = {
    setPerson(state, newValue) {
        state.person = newValue;
    },
    setPersons(state, newValue) {
        state.persons = newValue;
    },
};

export const actions = {
    createPerson(_,  data) {
        return new Promise((resolve) => {
            api.post("/persons", data).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    updatePerson(_, {id,data}) {
        return new Promise((resolve) => {
            api.put("/persons/"+id, data).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    deletePerson(_, id) {
        return new Promise((resolve) => {
            api.delete("/persons/"+id).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    fetchPerson({ commit }, {id}) {
        return new Promise((resolve,reject) => {
            api.get("/persons/"+id).then((res) => {
                commit("setPerson", res.data.data);
                resolve(res.data.data)
            }).catch(err=>{
                reject(err)
            })
        });
    },
    fetchPersons({ commit }, {page, limit, search, listType}) {
        let query = "?";
        if(listType){
            query+=`listType=${listType}`
        }else{
            if (search) {
                query += `name=${search}&`;
            }
            query += `page=${page}&`;
            query += `limit=${limit}&`;
        }
        return new Promise((resolve) => {
            api.get("/persons"+query).then((res) => {
                commit("setPersons", res.data.data);
                resolve(res.data.data)
            })
        });
    },
};
